import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/billing-terms/profile/loading';

export const Route = createFileRoute('/_private/settings/billing-terms/$id')({
  pendingComponent: Loading,
});
